import { render, staticRenderFns } from "./IconDoubleTrebleCrochet.vue?vue&type=template&id=e8ceee08&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports